/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

/**
 * Input type that lets a user remove a dynamically injected test section from a
 * form. Confirms via modal, then delegates to DocumentDynamicSectionManager to
 * tombstone the section registration, stage deletion of the underlying
 * TestInstance in the document's OnSave comprehension, and tear down the live
 * section views.
 */
class MaterialsTestSectionRemoverInputType extends PictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Prompt for confirmation, then remove the dynamic section registered at the
	 * given hash along with its underlying TestInstance (deleted on form save).
	 *
	 * @param {string} pRegistrationHash - The __DynamicSectionData registration hash for the section.
	 */
	requestSectionRemoval(pRegistrationHash)
	{
		const tmpSectionManager = this.pict.providers.DocumentDynamicSectionManager;
		if (!tmpSectionManager)
		{
			this.pict.log.error(`MaterialsTestSectionRemoverInputType: DocumentDynamicSectionManager provider not available; cannot remove section.`, { pRegistrationHash });
			return;
		}
		const tmpRegistration = this.pict.AppData.DocumentData?.ReportData?.FormData?.__DynamicSectionData?.[pRegistrationHash];
		if (!tmpRegistration)
		{
			this.pict.log.error(`MaterialsTestSectionRemoverInputType: No dynamic section registration found for hash [${pRegistrationHash}]; cannot remove section.`);
			return;
		}
		const tmpTestLabel = tmpRegistration.TestHash ? ` ${tmpRegistration.TestHash}` : '';
		this.fable.HeadlightModal.spawnModal(
			{
				title: 'Remove Test',
				message: `Remove test${tmpTestLabel} and its section from this form? The test will be deleted from the sample when the form is saved.`,
				confirmText: 'Remove Test',
				confirmIcon: 'trash-alt',
				confirmColor: 'is-danger',
			},
			() =>
			{
				tmpSectionManager.removeTestSection(pRegistrationHash);
			},
			null);
	}
}

module.exports = MaterialsTestSectionRemoverInputType;
